import { n as r } from "./property-BWlAHqg_.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function o(t) {
  return r({ ...t, state: !0 });
}
export {
  o as t
};
//# sourceMappingURL=state-STZTbIJp.js.map
